import React, { memo, Fragment } from 'react'
import { useOpeningHoursBox, OpeningHoursBoxProps } from './useOpeningHoursBox'
import styles from './OpeningHoursBox.module.scss'
import Modal from 'components/Modal/Modal'
import OpeningHoursItem from './OpeningHoursItem/OpeningHoursItem'

const OpeningHoursBox: React.FC<OpeningHoursBoxProps> = (
  props: OpeningHoursBoxProps
) => {
  const {
    openingHours,
    boxBgColor,
    boxTitleColor,
    hoursBg,
    getOpeningHoursResponseMessage,
    isLoading,
    isGetOpeningHoursSuccess,
    setShowOpeningHoursBox,
  } = useOpeningHoursBox(props)

  return (
    <div className={styles['opening-hours-box']}>
      <Modal
        title='Opening Hours'
        bgColor={boxBgColor}
        titleColor={boxTitleColor}
        hideFooter
        onClose={() => setShowOpeningHoursBox(false)}
      >
        {isLoading ? 'Loading...' : <Fragment />}
        {isGetOpeningHoursSuccess === false ? (
          <div className={styles.error}>{getOpeningHoursResponseMessage}</div>
        ) : (
          <Fragment />
        )}
        {openingHours && openingHours.length ? (
          openingHours.map((openingHoursItem, i) => (
            <OpeningHoursItem
              key={`opening-hours-${i}`}
              day={openingHoursItem.dayOfWeek}
              openTime={openingHoursItem.openTime}
              closeTime={openingHoursItem.closeTime}
              isClosed={openingHoursItem.isClosed}
              bg={boxTitleColor}
              text={boxBgColor}
              hoursText={boxTitleColor}
              hoursBg={hoursBg}
            />
          ))
        ) : (
          <Fragment />
        )}
      </Modal>
    </div>
  )
}

export default memo(OpeningHoursBox)
